import React from 'react';
import { ModalProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ModalDialog } from 'components/ModalDialog';
import { MODAL_DIALOG_WIDTH } from 'modules/core/constants';

interface IConfirmationDialog extends ModalProps {
  show: boolean;
  onSubmitModal: VoidFunction;
  onHide: VoidFunction;
}

export const ConfirmationDialog: React.FC<IConfirmationDialog> = ({ show, onSubmitModal, onHide }) => {
  const { t } = useTranslation();

  return (
    <ModalDialog
      show={show}
      title={t('confirmationDialog.title')}
      modalSize={MODAL_DIALOG_WIDTH.CUSTOM.PX_425}
      backdrop="static"
      keyboard={false}
      onHide={onHide}
      onSubmitModal={onSubmitModal}
      submitButtonTitle={t('common.buttons.confirm')}
      cancelButtonTitle={t('common.buttons.cancel')}
      showCloseButton={false}
      verticallyCentered={true}
    >
      {t('confirmationDialog.message')}
    </ModalDialog>
  );
};
